import SV from 'server-vars';
import { encode } from 'querystring';

function listenWindowClose(targetWindow) {
    return new Promise(resolve => {
        const interval = setInterval(() => {
            try {
                if (targetWindow === null || targetWindow.closed) {
                    clearInterval(interval);
                    resolve();
                }
            } catch (e) {
                resolve();
            }
        }, 500);
    });
}

function getNewBrowserWindowOptions() {
    const width = 665;
    const height = 500;
    const sW = screen.width;
    const sH = screen.height;
    return encode({
        width,
        height,
        toolbar: 'no',
        resizable: 'no',
        scrollbars: 'yes',
        left: (sW > width) ? Math.round((sW / 2) - (width / 2)) : 0,
        top: (sH > height) ? Math.round((sH / 2) - (height / 2)) : 0
    }, ',');
}

export function pin(payload) {
    const { newBrowserWindow, description, media, url } = payload || {};
    const options = (newBrowserWindow === true) ? getNewBrowserWindowOptions() : void 0;
    const pinterestWindow = window.open('', 'pinterest', options);
    pinterestWindow.location = `https://pinterest.com/pin/create/button/?url=${url}&media=${
        media
    }&description=${description}`;
    return listenWindowClose(pinterestWindow);
}

export function facebookShare(payload) {
    const { newBrowserWindow } = payload || {};
    const options = (newBrowserWindow === true) ? getNewBrowserWindowOptions() : void 0;
    const facebookWindow = window.open('', 'facebook', options);
    const url = `http://www.facebook.com/sharer.php?app_id=${SV.get('config.facebookAppId')}&u=${
        location.href
    }`;
    facebookWindow.location = url;
    return listenWindowClose(facebookWindow);
}
